import { dash } from 'radash'

export const showDividerTag = (index: number, arrayLength: number) => {
  return index >= 0 && arrayLength > 1 && index < arrayLength - 1
}

export const formatId = (text: string, prefix: string = 'id-') =>
  `${prefix}-${dash(text)}`
